// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/* Variables */\n\n/* -- Colors -- */\n\n.directionality-dropdown button {\n\t\t\n\t}\n\n.directionality-dropdown streamline-icon {\n\t}\n\n.directionality-dropdown .directionality-selector {\n\t\tmargin: 0 1em;\n\t\tpadding: 0.15em;\n\t\tborder: 1px solid rgb(0, 10, 45);\n\t}\n\n.directionality-dropdown .selected-directionality {\n\t\tbackground: rgba(0, 0, 30, 0.04);\n\t}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
